import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-pdf-guide',
  templateUrl: './card-pdf-guide.component.html',
  styleUrls: ['./card-pdf-guide.component.css']
})
export class CardPdfGuideComponent implements OnInit {

  @Input() city!: string;
  @Input() image!: string;
  @Input() description: string = 'Mapa de metro';
  @Input() link: string = '#';
  @Input() id: string;
  
  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  openPdfModal(mapName){
    this.router.navigateByUrl('pdf-view/'+mapName);
  }

}
